import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  error: Error | null;
}

/** Error boundary global do app (PRJ-005). */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // TODO: enviar para o servico de observabilidade quando definido.
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (this.props.fallback) return this.props.fallback;

    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
        <h1 className="text-lg font-semibold text-ink">Algo deu errado</h1>
        <p className="max-w-md text-sm text-ink-muted">
          A aplicacao encontrou um erro inesperado. Recarregue a pagina e tente novamente.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-brand-solid px-4 py-2 text-sm font-medium text-white hover:bg-brand-solid-hover"
        >
          Recarregar
        </button>
      </div>
    );
  }
}
